export default "__VITE_ASSET__960a7c3b__"